import { put, takeLatest } from "redux-saga/effects";

import {
  requestAddNoteToLead,
  requestCreateLead,
  requestDeleteLeadNote,
  requestKPISData,
  requestLeadList,
  requestLeadListNew,
  requestLeadStageChange,
  requestUpdateLead,
  requestLeadListCRUD,
} from "../../../services/Lead";
import {
  addLeadNoteFailure,
  addLeadNoteRequest,
  addLeadNoteSuccess,
  createLeadFailure,
  createLeadRequest,
  createLeadSuccess,
  deleteLeadNoteFailure,
  deleteLeadNoteRequest,
  deleteLeadNoteSuccess,
  fetchLeadListFailure,
  fetchLeadListFailureNew,
  fetchLeadListRequest,
  fetchLeadListRequestNew,
  fetchLeadListSuccessNew,
  fetchLeadListSuccess,
  fetchLeadListCRUDFailure,
  fetchLeadListCRUDSuccess,
  fetchLeadListCRUDRequest,
  getKPISFaliure,
  getKPISRequest,
  getKPISSuccess,
  getlastLeadFaliure,
  getlastLeadRequest,
  getlastLeadSuccess,
  updateLeadFailure,
  updateLeadRequest,
  updateLeadStageFailure,
  updateLeadStageRequest,
  updateLeadStageSuccess,
  updateLeadSuccess,
} from "../../reducers/lead";

export function* watchLeadSaga() {
  yield takeLatest(fetchLeadListRequest, FetchLeadList);
  yield takeLatest(fetchLeadListRequestNew, FetchLeadListNew);
  yield takeLatest(createLeadRequest, CreateLead);
  yield takeLatest(updateLeadRequest, UpdateLead);
  yield takeLatest(updateLeadStageRequest, UpdateLeadStage);
  yield takeLatest(addLeadNoteRequest, addLeadNote);
  yield takeLatest(deleteLeadNoteRequest, deleteLeadNote);
  yield takeLatest(getlastLeadRequest, lastleadData);
  yield takeLatest(getKPISRequest, kpis);
  yield takeLatest(fetchLeadListCRUDRequest, FetchLeadListCRUD);
}

/**
 * @typedef {Object} PAYLOAD
 * @property {number} skip
 *
 * @typedef {Object} PARAMS
 * @property {PAYLOAD} payload
 *
 */

/**
 *
 * @param {PARAMS} param0
 */
function* FetchLeadList({ payload }) {
  try {
    const response = yield requestLeadList(payload);
    if(!payload.cancelRequest){
      yield put(fetchLeadListSuccess(response));
    }
  } catch (error) {
    yield put(fetchLeadListFailure("Failed to get list of Leads"));
  }
}
function* FetchLeadListNew({ payload }) {
  try {
    const response = yield requestLeadListNew(payload);
    yield put(fetchLeadListSuccessNew(response));
  } catch (error) {
    yield put(fetchLeadListFailureNew("Failed to get list of Leads"));
  }
}
function* FetchLeadListCRUD({ payload }) {
  try {
    const response = yield requestLeadListCRUD(payload);
    yield put(fetchLeadListCRUDSuccess(response));
  } catch (error) {
    yield put(fetchLeadListCRUDFailure("Failed to get list of Leads"));
  }
}

/**
 *
 * @param {LeadForm} param0
 */
function* CreateLead({ payload }) {
  try {
    const response = yield requestCreateLead(payload);
    yield put(createLeadSuccess(response.data));
  } catch (error) {
    const message = error.response?.data?.message || "Unknown Error";
    yield put(createLeadFailure(message));
  }
}

/**
 *
 * @param {LeadForm} param0
 */
function* UpdateLead({ payload }) {
  try {
    const response = yield requestUpdateLead(payload);
    yield put(updateLeadSuccess(response.data));
  } catch (error) {
    yield put(updateLeadFailure("Failed to get list of Leads"));
  }
}

/**
 *
 * @param {LeadStageChange} param0
 */
function* UpdateLeadStage({ payload }) {
  try {
    const response = yield requestLeadStageChange(payload);
    yield put(updateLeadStageSuccess(response.data));
  } catch (error) {
    yield put(updateLeadStageFailure("Failed to update lead stage"));
  }
}

/**
 *
 * @param {LeadStageChange} param0
 */
function* addLeadNote({ payload }) {
  try {
    const response = yield requestAddNoteToLead(payload);
    yield put(addLeadNoteSuccess(response.data));
  } catch (error) {
    yield put(addLeadNoteFailure("Failed to add note to lead"));
  }

  //   try {
  //     const response = yield requestAddNoteToLead(payload);
  //     console.log(response);
  //     yield put(addLeadNoteSuccess(response.data));
  // } catch (error) {
  //     yield put(
  //       addLeadNoteFailure('Failed to add note to lead')
  //     );
  // }
}

/**
 *
 */
function* deleteLeadNote({ payload }) {
  try {
    yield requestDeleteLeadNote(payload);
    yield put(deleteLeadNoteSuccess(payload));
  } catch (error) {
    yield put(deleteLeadNoteFailure("Failed to delete note to lead"));
  }
}
function* lastleadData({ payload }) {
  try {
    const response = yield requestLeadList(payload);
    yield put(getlastLeadSuccess(response));
  } catch (error) {
    yield put(getlastLeadFaliure("Failed to get list of Leads"));
  }
}
function* lastleadDataNew({ payload }) {
  try {
    const response = yield requestLeadListNew(payload);
    yield put(getlastLeadSuccessNew(response));
  } catch (error) {
    yield put(getlastLeadFaliureNew("Failed to get list of Leads"));
  }
}

function* kpis({ payload }) {
  try {
    const response = yield requestKPISData(payload);
    yield put(getKPISSuccess(response));
  } catch (error) {
    yield put(getKPISFaliure("Failed to data"));
  }
}
